const RedditPixel = () => {
  const serviceName = 'RedditPixel';
  let hasInitializedPixel = false;

  const initRedditPixel = (rdt) => {
    if (hasInitializedPixel) return;
    hasInitializedPixel = true;

    // Placeholder values to be replaced with real Reddit pixel configuration.
    rdt('init', 'a2_gzim0g26k3hd');
  };

  const withRedditPixel = (cb) => {
    if (typeof window.rdt === 'function') {
      initRedditPixel(window.rdt);
      cb(window.rdt);
      return;
    }

    window.addEventListener('ResyRedditLoaded', () => {
      if (typeof window.rdt === 'function') {
        initRedditPixel(window.rdt);
        cb(window.rdt);
      }
    }, { once: true });
  };

  const event = () => {};

  const page = () => {
    withRedditPixel((rdt) => {
      rdt('track', 'PageVisit');
    });
  };

  const purchase = () => {
    withRedditPixel((rdt) => {
      rdt('track', 'Purchase');
    });
  };

  return {
    event,
    page,
    purchase,
    serviceName,
  };
};

export default RedditPixel();
